import { StockActionTypes } from '../interfaces';

export const attachExchange = () => ({
  type: StockActionTypes.STOCK_ATTACH_LISTENERS,
});

export const detachExchange = () => ({
  type: StockActionTypes.STOCK_DETACH_LISTENERS,
});
